import { render, staticRenderFns } from "./block-rental-requirement.vue?vue&type=template&id=2e010ec4&scoped=true"
import script from "./block-rental-requirement.vue?vue&type=script&lang=js"
export * from "./block-rental-requirement.vue?vue&type=script&lang=js"
import style0 from "./block-rental-requirement.vue?vue&type=style&index=0&id=2e010ec4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e010ec4",
  null
  
)

export default component.exports